export default class DocumentService {
    constructor(httpService) {
        this._http = httpService;
    }

    getContractDocument = (id) => {
        return this._http.get(`/doc/${id}`);
    };
}